<div id="newly-eligible-banner" class="card bg-primary" style="padding: 15px">
    <div fxLayout="column" fxLayoutAlign="center center" class="fxGap-medium">
      <h4 class="card-title">Spousal Attestation</h4>
      <ng-container *ngIf="!subscriber?.isSelfPay" class="card-text">
        <p class="banner-text card-text">
          You must complete the spouse or state-registered domestic partner (SRDP) coverage premium surcharge attestation for coverage effective January {{nextYear | date:'yyyy'}}.
          If you do not complete the attestation, you will be charged the $50 monthly premium surcharge.
        </p>
        <p class="banner-text card-text">
          To attest, select the Open Enrollment button and complete the dependent questions. When prompted to review your dependents, select "Edit" for your spouse
          or SRDP and complete the attestation. If you are removing your spouse or SRDP from medical coverage for {{nextYear | date:'yyyy'}}, you do not need to
          complete the attestation.
        </p>
      </ng-container>
      <ng-container *ngIf="subscriber?.isSelfPay" class="card-text">
        <p class="banner-text card-text">
          Select the 'Open Enrollment change request' link in the Open Enrollment banner above. Then use the drop down to create an 'Open Enrollment change request'. 
          You will complete the request to confirm your health plan coverage and attest to the spousal surcharge for {{nextYear | date:'yyyy'}}.
        </p>
      </ng-container>
    </div>
  </div>